module.exports = __webpack_public_path__ + "img/binti-night-masquerade.292fe060.png";